import PageTopbar from "../../components/PageTopbar";
import PageSeo from "../../components/PageSeo";
import Nd1SiteNav from "./Nd1SiteNav";
import Nd1SiteFooter from "./Nd1SiteFooter";
import { buildBreadcrumbJsonLd, buildBreadcrumbNavItems, buildPublicPageUrl } from "../../lib/pageSeo";
import "../nd1.css";

export default function Nd1BlogArticleShell({ seo, eyebrow, title, children }) {
  const pagePath = seo?.canonicalPath || seo?.path || "/blog";
  const pageUrl = buildPublicPageUrl(pagePath);
  const extraJsonLd = seo?.jsonLd
    ? Array.isArray(seo.jsonLd)
      ? seo.jsonLd
      : [seo.jsonLd]
    : [];
  const mergedSeo = {
    ...seo,
    jsonLd: [
      buildBreadcrumbJsonLd([
        { name: "Home", url: buildPublicPageUrl("/") },
        { name: "Blog", url: buildPublicPageUrl("/blog") },
        { name: title, url: pageUrl },
      ]),
      ...extraJsonLd,
    ],
  };

  return (
    <div className="nd1-root">
      <PageSeo {...mergedSeo} />

      <a href="#nd1-main" className="nd1-skip-link">
        Skip to content
      </a>

      <Nd1SiteNav />

      <main id="nd1-main">
        <section className="nd1-shell nd1-section nd1-article-section">
          <PageTopbar
            backTo="/blog"
            backLabel="Back to blog"
            breadcrumbItems={buildBreadcrumbNavItems([
              { name: "Home", path: "/" },
              { name: "Blog", path: "/blog" },
              { name: title, path: pagePath, current: true },
            ])}
          />

          <article className="nd1-card nd1-article">
            <span className="nd1-eyebrow">{eyebrow}</span>
            <h2 className="nd1-article__title">{title}</h2>
            {children}
          </article>
        </section>
      </main>

      <Nd1SiteFooter />
    </div>
  );
}
